import React from "react";
import { Box, Container, Grid, Link } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";


function Slider() {
  // Data for each card
  const cards = [
    {
      id: 1,
      title: "Ganesh Chaturthi",
      description:
        "Discover why Ganesh Chaturthi is celebrated. Know the mythological story of Lord Ganesha. Understand the meaning of the 10-day festival. Explore its religious significance, sacred rituals, and grand celebrations...",
      image: "/assets/home/blogs/ganesh-chaturthi.png",
    },
    {
      id: 2,
      title: "Gangotri Temple: In the Lap of the Ganges and the Himalayas",
      description:
        "In the Lap of the Ganges and the Himalayas. Explore one of the most sacred pilgrimage shrines dedicated to Goddess Ganga, nestled amidst snow-clad Himalayan peaks, peaceful cedar forests, and divine spiritual serenity...",
      image: "/assets/blog/blog2.svg",
    },
    {
      id: 3,
      title: "Dwarkadhish Temple: The Eternal Kingdom of Lord Krishna",
      description:
        "The Eternal Kingdom of Lord Krishna. A sacred tale of spiritual connection and ancient architectural brilliance, where devotees immerse themselves in centuries-old traditions, devotion, and the divine coastal aura of Dwarka...",
      image: "/assets/blog/blog3.svg",
    },
    {
      id: 4,
      title: "Ganesh Chaturthi",
      description:
        "Discover why Ganesh Chaturthi is celebrated. Know the mythological story of Lord Ganesha. Understand the meaning of the 10-day festival. Explore its religious significance, sacred rituals, and grand celebrations...",
      image: "/assets/home/blogs/ganesh-chaturthi.png",
    },
    {
      id: 5,
      title: "Gangotri Temple: In the Lap of the Ganges and the Himalayas",
      description:
        "In the Lap of the Ganges and the Himalayas. Explore one of the most sacred pilgrimage shrines dedicated to Goddess Ganga, nestled amidst snow-clad Himalayan peaks, peaceful cedar forests, and divine spiritual serenity...",
      image: "/assets/blog/blog2.svg",
    },
    {
      id: 6,
      title: "Dwarkadhish Temple: The Eternal Kingdom of Lord Krishna",
      description:
        "The Eternal Kingdom of Lord Krishna. A sacred tale of spiritual connection and ancient architectural brilliance, where devotees immerse themselves in centuries-old traditions, devotion, and the divine coastal aura of Dwarka...",
      image: "/assets/blog/blog3.svg",
    },
  ];

  return (
    <section>
    <Box className="blogSliderBox">
      <Container maxWidth="md">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Box className="templeInnerHeading" textAlign="center">
              <h2>Explore Latest Blogs</h2>
            </Box>
          </Grid>

          <Grid item xs={12}>
          <Box>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={3}
              navigation
            //   pagination={{ clickable: true }}
            autoplay={{
    delay: 30000,  
    disableOnInteraction: false,
  }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1200: { slidesPerView: 3 }, // Optional: 4 cards on large screens
              }}
            >
              {cards.map((card) => (
                <SwiperSlide key={card.id}>
                <Box className="blogSlider">
                  <Box className="blogCard">
                    <Box className="blogCardImage">
                      <img src={card.image} alt={card.title} />
                    </Box>
                    <Box className="blogCardDetails">
                      <div className="blogHeading">{card.title}</div>
                      <p>{card.description}</p>
                      <Link href="coming-soon">Read full article</Link>
                    </Box>
                  </Box>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      
    </Box>
    </section>
  );
}

export default Slider;
